// extracted by mini-css-extract-plugin
module.exports = {"root":"BpcedR","checkbox":"b0GHqL","checkboxError":"zK_JLv"};